import React, { Component } from "react";
import {  Alert } from "reactstrap";

class AlertResultsPage extends Component {

  render() {

    return(
      <div>

      <Alert color="info" text-align="center">
      If no requests populate, please refresh the page and input your email again.
      </Alert>

      </div>
    )
  }
}

export default AlertResultsPage;